/**
 * Where a fee negotiation stands. The two pending states name the side that
 * must move next; the rest are terminal.
 */
export var BusinessFeeNegotiationStatus;
(function (BusinessFeeNegotiationStatus) {
    /** Afriex must accept, counter or decline. */
    BusinessFeeNegotiationStatus["PendingAdmin"] = "PENDING_ADMIN";
    /** The business must accept, counter or withdraw. */
    BusinessFeeNegotiationStatus["PendingBusiness"] = "PENDING_BUSINESS";
    /** Both sides agreed; this writes the business's fee rules. */
    BusinessFeeNegotiationStatus["Accepted"] = "ACCEPTED";
    /** Afriex declined. The business keeps its current rates. */
    BusinessFeeNegotiationStatus["Rejected"] = "REJECTED";
    /** The business withdrew. */
    BusinessFeeNegotiationStatus["Cancelled"] = "CANCELLED";
})(BusinessFeeNegotiationStatus || (BusinessFeeNegotiationStatus = {}));
//# sourceMappingURL=BusinessFeeNegotiationStatus.js.map